export const BODY_SIDEBAR_SHOWN_CLASS = 'menu-shown';
